import { gsap } from 'gsap'

export default class Accordion {
  list: HTMLElement[]
  toggleBtnClass: string
  itemClass: string
  firstDisplay: boolean
  onlyDisplay: boolean
  onChange: ((parent: HTMLElement, value: boolean, i: number) => void) | null
  heights:
    | [
        {
          height: number
          paddingTop: number
          paddingBottom: number
        }
      ]
    | []

  constructor(
    list: HTMLElement[],
    config: {
      toggleBtnClass?: string
      itemClass?: string
      firstDisplay?: boolean
      onlyDisplay?: boolean
      onChange?: (parent: HTMLElement, value: boolean, i: number) => void
    }
  ) {
    // 変数宣言
    // ---------------------------------------------
    this.list = list
    this.toggleBtnClass = config.toggleBtnClass || 'ac_toggle-btn'
    this.itemClass = config.itemClass || 'ac_item'
    this.firstDisplay = config.firstDisplay || false
    this.onlyDisplay = config.onlyDisplay || false
    this.onChange = config.onChange || null
    this.heights = []

    // 初期の処理
    // ---------------------------------------------
    this.getHeights()
    this.heightZero()
    this.setClickEvent()

    if (this.firstDisplay) this.onUpdate(0)

    window.addEventListener('resize', () => this.resize())
  }

  getHeights() {
    this.list.forEach((elm, i) => {
      const target: Element = elm.getElementsByClassName(this.itemClass)[0]
      if (target) {
        const children: never[] = gsap.utils.toArray(
          `.${this.itemClass} > *`,
          target
        )
        let height = 0
        let beforeMargin = 0

        const targetPT = parseFloat(
          gsap.getProperty(target, 'paddingTop', 'px') as string
        )
        const targetPB = parseFloat(
          gsap.getProperty(target, 'paddingBottom', 'px') as string
        )

        children.forEach((child: HTMLElement) => {
          const offsetHeight = child.offsetHeight
          const mt = parseFloat(
            gsap.getProperty(child, 'marginTop', 'px') as string
          )
          const marginTop = beforeMargin <= mt ? mt - beforeMargin : 0
          const marginBottom = parseFloat(
            gsap.getProperty(child, 'marginBottom', 'px') as string
          )

          height += offsetHeight + marginTop + marginBottom

          beforeMargin = mt
        })
        this.heights[i] = {
          height: height,
          paddingTop: targetPT,
          paddingBottom: targetPB,
        }
      }
    })
  }

  setClickEvent() {
    this.list.forEach((elm, i) => {
      const btnList: never[] = gsap.utils.toArray(
        `.${this.toggleBtnClass}`,
        elm
      )
      btnList.forEach((btnElm: HTMLElement) => {
        btnElm.addEventListener('click', (e) => this.onUpdate(i, e))
      })
    })
  }

  onUpdate(i: number, e: any = null) {
    if (e) e.preventDefault()

    const parent = this.list[i]
    const value = !Object.values(parent.classList).includes('active')
    const target = parent.getElementsByClassName(this.itemClass)[0]

    if (this.onlyDisplay) this.removeActive()

    if (value) {
      const h =
        this.heights[i].height +
        this.heights[i].paddingTop +
        this.heights[i].paddingBottom
      gsap.to(target, {
        height: h,
        paddingTop: this.heights[i].paddingTop,
        paddingBottom: this.heights[i].paddingBottom,
        duration: 0.4,
      })
      parent.classList.add('active')
    } else {
      gsap.to(target, {
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        duration: 0.4,
      })
      parent.classList.remove('active')
    }

    if (this.onChange) this.onChange(parent, value, i)
  }

  removeActive() {
    this.list.forEach((elm, i) => {
      elm.classList.remove('active')
      const target = elm.getElementsByClassName(this.itemClass)[0]
      gsap.to(target, {
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        duration: 0.4,
      })
    })
  }

  heightZero() {
    this.list.forEach((elm, i) => {
      const target = elm.getElementsByClassName(this.itemClass)[0]
      gsap.set(target, {
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        overflow: 'hidden',
      })
    })
  }

  resize() {
    this.getHeights()
    this.list.forEach((elm, i) => {
      if (Object.values(elm.classList).includes('active')) {
        const target = elm.getElementsByClassName(this.itemClass)[0]
        const h =
          this.heights[i].height +
          this.heights[i].paddingTop +
          this.heights[i].paddingBottom
        gsap.to(target, {
          height: h,
          paddingTop: this.heights[i].paddingTop,
          paddingBottom: this.heights[i].paddingBottom,
          duration: 0.2,
        })
      }
    })
  }
}
